import AccountAuthenticateForm from './AccountAuthenticateForm';

export default AccountAuthenticateForm;
